// Maps named archetype → Energy Pattern + Action Instinct
export const ARCHETYPE_MAP = {
  "Vision Explorer":       "Gold Owl",
  "Concept Architect":     "Gold Dolphin",
  "Visionary Initiator":   "Gold Hawk",
  "Adaptive Designer":     "Gold Beaver",
  "Insight Strategist":    "Green Owl",
  "Strategic Architect":   "Green Dolphin",
  "Decisive Catalyst":     "Green Hawk",
  "Precision Implementer": "Green Beaver",
  "Strategic Pathfinder":  "Orange Owl",
  "Strategic Accelerator": "Orange Dolphin",
  "Momentum Driver":       "Orange Hawk",
  "Results Builder":       "Orange Beaver",
  "Grounded Advisor":      "Blue Owl",
  "Systems Steward":       "Blue Dolphin",
  "Deliberate Initiator":  "Blue Hawk",
  "Sustainable Operator":  "Blue Beaver",
};

export const ARCHETYPE_GROUPS = [
  { label: "Gold — Ideation", names: ["Vision Explorer", "Concept Architect", "Visionary Initiator", "Adaptive Designer"] },
  { label: "Green — Analysis", names: ["Insight Strategist", "Strategic Architect", "Decisive Catalyst", "Precision Implementer"] },
  { label: "Orange — Momentum", names: ["Strategic Pathfinder", "Strategic Accelerator", "Momentum Driver", "Results Builder"] },
  { label: "Blue — Consistency", names: ["Grounded Advisor", "Systems Steward", "Deliberate Initiator", "Sustainable Operator"] },
];
